import {lazy} from '@aboutyou/lazy-imports';
import {LoadingPageSpinner} from '@aboutyou/ui-components';
import React from 'react';

export const SearchResultsPage = lazy(
  () =>
    import('./SearchResultsPage.eager').then(mod => ({
      default: mod.SearchResultsPage,
    })),
  {
    fallback: <LoadingPageSpinner />,
    aboveTheFold: true,
  },
);
